import {Component, inject} from '@angular/core';
import {
  DsBoxModule,
  DsButtonModule,
  DsFormFieldModule,
  DsModalModule,
  DsSelectModule,
  SelectListOption
} from '@bmw-ds/components';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {Outlet} from '../../core/dealer/models/outlet';
import {DealerDataService} from '../../core/dealer/services/dealer-data.service';
import {UserService} from '../../core/user/services/user.service';
import {VisibilityService} from '../../core/user/services/visibility.service';
import {VehicleType} from '@service-and-repairs/awpintegrationlib';
import {RouterLink} from '@angular/router';
import {UserDropdownComponent} from '../user-dropdown/user-dropdown.component';
import {ConfigurationOverlayComponent} from '../configuration-overlay/configuration-overlay.component';
import {ImprintComponent} from './imprint/imprint.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    RouterLink,
    DsFormFieldModule,
    DsSelectModule,
    DsButtonModule,
    UserDropdownComponent,
    DsModalModule,
    DsBoxModule,
    ConfigurationOverlayComponent,
    TranslateModule,
    ImprintComponent
  ]
})
export class HeaderComponent {
  visibilityService: VisibilityService = inject(VisibilityService);
  dealerDataService: DealerDataService = inject(DealerDataService);
  private readonly translate: TranslateService = inject(TranslateService);
  private readonly userService: UserService = inject(UserService);

  selectedOutlet: Outlet;
  outletDropdownOptions: SelectListOption[] = [];
  selectedOutletId: string | string[];

  viewState = {
    settingsDialogVisible: false,
    userDropdownVisible: false,
    configurationDialogVisible: false,
    imprintVisible: false
  };

  constructor() {
    const dealerDataService: DealerDataService = this.dealerDataService;

    this.selectedOutlet = dealerDataService.getSelectedOutlet();
    this.userService.user$.subscribe(() =>
      this.selectedOutletId = this.dealerDataService.outlets
        ?.indexOf(this.dealerDataService.getSelectedOutlet()).toString()
    );

    this.createOutletDropdownData();

    this.translate.onLangChange.subscribe(this.createOutletDropdownData.bind(this));
  }

  openConfiguration(): void {
    document.getElementById('awp-frontend-configuration')?.['api'].show();
    this.viewState.configurationDialogVisible = true;
  }

  outletDropdownChanged(): void {
    this.selectedOutlet = this.dealerDataService.outlets[this.selectedOutletId as string];
    this.dealerDataService.setSelectedOutlet(this.selectedOutlet);
  }

  private createOutletDropdownData(): void {
    this.outletDropdownOptions = [];
    if (this.dealerDataService.outlets) {
      this.dealerDataService.outlets.forEach((outlet: Outlet, index: number) => {
        this.outletDropdownOptions.push({
          label: outlet.toString(this.translate),
          id: index.toString(),
          icon: outlet.vehicleType === VehicleType.MOTORCYCLE ? 'motorcycle' : 'car'
        });

        // initial value selection based on id, which is just the index of the selected outlet
        const businessPartner = outlet.businessPartner;
        const selectedBusinessPartner = this.selectedOutlet.businessPartner;
        if (businessPartner.getDistributionPartnerNumber() === selectedBusinessPartner.getDistributionPartnerNumber()
          && businessPartner.getOutletNumber() === selectedBusinessPartner.getOutletNumber()
          && outlet.vehicleType === this.selectedOutlet.vehicleType) {
          this.selectedOutletId = index.toString();
        }
      });
      this.outletDropdownOptions.sort((a: SelectListOption, b: SelectListOption) => a.label.localeCompare(
        b.label,
        undefined,
        {numeric: true}
      ));
    }
  }
}
